import React from "react";
import { Segment, Container, Grid, Header, Button, List, Divider, Image } from "semantic-ui-react";
import Layout from "../../../components/Layout";
import FeaturesTable from "./features";


export const info = {
  title : 'Branding',
  icon : 'paint brush',
  subtitle: 'Make every pixel of the User Experience brand compliant'
}

export { FeaturesTable };

export default () => (
  <Layout section="products" title={info.title}>
    <div style={{ position: 'relative' }}>
      <div style={{ background: 'rgb(30,45,179)', paddingBottom: '100px' }}>
		    <Container text style={{ padding: "4em 0" }}>
          <Header
            as="h1"
            content={info.title}
            inverted
            style={{
              fontSize: "3em",
              fontWeight: "normal",
              marginBottom: 0,
              marginTop: "1.5em",
            }}
          />
          <Header
            as="h2"
            content={info.subtitle}
            inverted
            style={{
              fontSize: "1.7em",
              fontWeight: "normal",
              marginTop: "1.5em",
            }}
          />
          <a
            href="https://appexchange.salesforce.com/appxListingDetail?listingId=a0N3A00000GE6liUAD"
            target="_blank"
          >
            <Button inverted>Try now</Button>
          </a>
          <Header.Subheader style={{ color: "lightgray", margin: "8px" }}>
            Free 30 Day Trial
          </Header.Subheader>
        </Container>
      </div>
      <div className="wave-divider">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" className="shape-fill"></path>
        </svg>
      </div>
    </div>

    <Segment style={{ padding: "2em" }} vertical>
      <Container>
        <Grid columns={2} stackable>

          <Grid.Row style={{margin: '2em 0'}}>
            <Grid.Column verticalAlign="middle">
              <Header as="h1">
                Brand every pixel of the User Experience
              </Header>
              <p>Take control over each screen displayed to the user during registration, consent, multifactor authentication</p>
              <List bulleted>
                <List.Item>Authentication</List.Item>
                <List.Item>Registration</List.Item>
                <List.Item>Consent</List.Item>
                <List.Item>Multifactor authentication</List.Item>
              </List>
            </Grid.Column>
            <Grid.Column>
              <Image src="/images/branding.jpg" alt="Brand every screen"
                bordered
                style={{
                  boxShadow: "0 1px 2px 0 rgba(34,36,38,.15)",
                  padding: "16px",
                }}/>
            </Grid.Column>
          </Grid.Row>

        </Grid>

        <Divider horizontal style={{ margin: "6em 0 4em" }}>
          <span>CYM Identity Features</span>
        </Divider>

        <FeaturesTable />
      </Container>
    </Segment>

  </Layout>
);
